import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { gradientStyle } from '@/modules/AiAgents/constants';
import { useGoToAydiAi } from '@/modules/AiAgents/hooks/useGoToAydiAi';
import routes from '@/shared/constant/routes';

import SendIcon from '~/images/shared/GradientSend.svg';

const removedRoutes = [routes.aydiIntelligence, routes.subscription];

const AiSearchBox = () => {
  const router = useRouter();
  const { t } = useTranslation('ai');
  const { register, handleSubmit, reset } = useForm<{ query: string }>();
  const { redirectToAydiAi } = useGoToAydiAi();

  if (removedRoutes.some((r) => router.pathname.startsWith(r))) {
    return null;
  }

  const submitHandler = (data: { query: string }) => {
    // Reset the input field
    reset();
    redirectToAydiAi(data.query);
  };

  return (
    <form
      onSubmit={handleSubmit(submitHandler)} // Use handleSubmit from react-hook-form
    >
      <div className=' relative w-[390px] rounded-[12px]' style={gradientStyle}>
        <input
          {...register('query')} // Register the input field with react-hook-form
          className='border-gray-300 border h-[36px] w-full  
        rounded-[12px]  bg-gradient-to-b from-[rgba(52,50,199,0.05)]
        to-[rgba(182,50,199,0.05)]
        p-2 transition-all duration-300 placeholder:text-[#083A71]
        focus:shadow-[0_0_8px_2px_rgba(66,153,225,0.5),0_0_8px_2px_rgba(236,72,153,0.4)] focus:outline-none
        '
          placeholder={t('ask-anything')}
        />
        <button
          type='submit'
          className='end-0 absolute top-1/2 
          -translate-y-1/2 ltr:-translate-x-[150%] rtl:translate-x-[150%]'
        >
          <SendIcon width={25} height={25} />
        </button>
      </div>
    </form>
  );
};

export default AiSearchBox;
